import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "../../components";
import handleApiError from "../../utils/handleError";
import axiosClient from "../../api/axiosClient";
import {
  Button,
  Col,
  Divider,
  Empty,
  notification,
  Popconfirm,
  Row,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import CommentList from "./Comment";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";

export default function SupportTicket() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [ticket, setTicket] = useState<any>({});
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await axiosClient.get(`support/ticket/${id}`);
        const comments = await axiosClient.get(`support/ticket/${id}/comment`);
        setTicket(res.data);
        if (comments?.data?.length) {
          setComments(
            comments.data.sort(
              (a: any, b: any) =>
                new Date(b.commented_date).getTime() -
                new Date(a.commented_date).getTime()
            )
          );
        }
      } catch (error) {
        handleApiError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  function handleComment(e: any) {
    setComment(e.target.value);
  }
  async function handleSend() {
    try {
      setLoading(true);
      await axiosClient.post(`/support/ticket/${id}/comment`, {
        message: comment,
      });
      const comments = await axiosClient.get(`support/ticket/${id}/comment`);

      if (comments?.data?.length) {
        setComments(
          comments.data.sort(
            (a: any, b: any) =>
              new Date(b.commented_date).getTime() -
              new Date(a.commented_date).getTime()
          )
        );
      }
      setComment("");
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  }

  async function handleClose(id: any) {
    setLoading(true);
    try {
      await axiosClient.post(`support/ticket/${id}/transition`, {
        status: "closed",
      });
      const res = await axiosClient.get(`support/ticket/${id}`);
      setTicket(res.data);
      notification.success({
        message: "Closed",
        description: "Ticket closed successfully",
      });
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <Loading />;
  return (
    <div style={{ width: "100%" }}>
      <div
        className="book_slot_exam_detail"
        style={{ marginBottom: 30, justifyContent: "space-between" }}
      >
        <div className="book_slot_pill">
          <h5>Name</h5>
          <h5>{ticket.title}</h5>
        </div>
        <div className="book_slot_pill">
          <h5>Ticket ID</h5>
          <h5>{ticket.ticketId}</h5>
        </div>
        <div className="book_slot_pill">
          <h5>Date</h5>
          <h5>{ticket.sendDate}</h5>
        </div>
        {ticket.status === "closed" ? (
          <div className="book_slot_pill">
            <h5>Status</h5>
            <h5>{capitalizeFirstLetter(ticket.status)}</h5>
          </div>
        ) : null}
      </div>

      {ticket.status !== "closed" ? (
        <Row gutter={[20, 20]} style={{ marginBottom: 30 }}>
          <Col span={24}>
            <TextArea rows={5} value={comment} onChange={handleComment} />
          </Col>
          <Col>
            <Button onClick={handleSend}>Add Comment</Button>
          </Col>
          <Popconfirm
            title="Close the ticket"
            description="Are you sure to close the ticket?"
            onConfirm={() => handleClose(ticket.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary">Close Ticket</Button>
          </Popconfirm>
        </Row>
      ) : null}

      <h4>Comments</h4>

      <Divider />

      {comments?.length === 0 ? <Empty /> : <CommentList comments={comments} />}
    </div>
  );
}
